// Convert date string to milliseconds
export const strDateToMilliseconds = (dateStr: any) => {
  let date = new Date(dateStr);
  return date.getTime();
}

export function dateToRelativeFormat(date: string): string {
  const oneDay: number = 24 * 60 * 60 * 1000;
  const today: Date = new Date(); 
  const formatDate: Date = new Date(date); 

  const difference = Math.round(Math.abs((today.getTime() - formatDate.getTime()) / oneDay));

  if (difference === 0) {
    return 'hoy';
  } else if (difference === 1) {
    return 'ayer';
  } else {
    return 'la semana pasada';
  }
}

export const formatDateToText = (dateString: string): string => {
  const date = new Date(dateString);

  const day = date.getDate();
  const year = date.getFullYear();

  const months = [
    'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
  ];

  const month = months[date.getMonth()];

  return `${day} de ${month} de ${year}`;
};
